import { isProduction, formGraphQLUrl } from 'utils/url';
import { getAccessToken } from 'data/connection/storage';

import type { TypePolicies } from '@apollo/client';

export const LinkConfig: { uri: string } = {
    uri: formGraphQLUrl(false),
};

export const typePolicies: TypePolicies = {
    RequestedOrderProduct: { keyFields: ['orderId', '_id'] },
    OrderProduct: { keyFields: ['orderId', '_id'] },
    BoxProduct: { keyFields: ['boxId', '_id'] },
    User: {
        fields: {
            profile: {
                merge(existing: any, incoming: any) {
                    return { ...existing, ...incoming };
                },
            },
        },
    },
    Order: {
        fields: {
            stateHistory: {
                merge: false,
            },
            products: {
                merge: false,
            },
            price: {
                merge: false,
            },
        },
    },
    Query: {
        fields: {
            archivedOrders: {
                keyArgs: ['totemId'],
                merge(
                    existing: { archivedOrders: any[]; hasMore?: boolean } = { archivedOrders: [] },
                    incoming: { archivedOrders: any[]; hasMore?: boolean },
                    { readField }: { readField: (field: string, obj: any) => any },
                ) {
                    const newOrders: any[] = [];
                    const existingOrderIds = existing.archivedOrders.map((order) => readField('_id', order));
                    incoming.archivedOrders.forEach((item) => {
                        if (!existingOrderIds.includes(readField('_id', item))) {
                            newOrders.push(item);
                        }
                    });
                    return {
                        archivedOrders: [...existing.archivedOrders, ...newOrders],
                        hasMore: incoming.hasMore,
                    };
                },
            },
            getInvoices: {
                keyArgs: ['organizationId'],
                merge(
                    existing: { invoices: any[]; hasMore?: boolean } = { invoices: [] },
                    incoming: { invoices: any[]; hasMore?: boolean },
                    { readField }: { readField: (field: string, obj: any) => any },
                ) {
                    const newInvoices: any[] = [];
                    const existingInvoicesIds = existing.invoices.map((invoice) => readField('id', invoice));
                    incoming.invoices.forEach((item) => {
                        if (!existingInvoicesIds.includes(readField('id', item))) {
                            newInvoices.push(item);
                        }
                    });
                    return {
                        invoices: [...existing.invoices, ...newInvoices],
                        hasMore: incoming.hasMore,
                    };
                },
            },
        },
    },
};

export const ClientConfig: { connectToDevTools: boolean } = {
    connectToDevTools: !isProduction,
};

export const WSConfig: {
    url: string;
    shouldRetry: () => boolean;
    connectionParams: () => Promise<{ token: string; webapporigin: boolean }>;
} = {
    url: formGraphQLUrl(true),
    shouldRetry: () => true,
    connectionParams: async () => ({
        token: getAccessToken() || '',
        webapporigin: true,
    }),
};
